<template lang="pug">
    .tab-content
        z-select(
            label="Тип получателя"
            v-model="customer.type"
            :required="true"
            name="recipient_type"
            id="recipient_type"
            v-validate="'required'"
            v-bind:error="errors.first('recipient_type')"
            v-bind:disabled="blocked"
            inline
            v-on:change="changeType"
            v-bind:dirty.sync="dirtyObj.type"
        )
            option(v-bind:value="'1'") Юридическое лицо
            option(v-bind:value="'3'") Индивидуальный предприниматель
            option(v-bind:value="'2'") Физическое лицо

        div(v-show="customer && !!([1,3].indexOf(parseInt(customer.type))+1)")
            ZInputAutocomplete(
                v-bind:update-on-input="true"
                label="ИНН"
                v-bind:items="customersUl"
                v-model="customer.inn"
                v-bind:callback="searchCustomerByInn"
                v-on:select="selectCustomer"
                v-on:clear="clearCustomer"
                v-bind:length-on-search="3"
                display-property="inn"
                display-property-list="ul_inn_label"
                property="inn"
                v-bind:default="customer.inn"
                :required="!!([1,3].indexOf(parseInt(customer.type))+1)"
                name="recipient_inn"
                id="recipient_inn"
                v-validate="{'required': !!([1,3].indexOf(parseInt(customer.type))+1)}"
                v-bind:error="errors.first('recipient_inn')"
                data-vv-name="recipient_inn"
                v-bind:data-vv-as="' '"
                ref="inn"
                inline
                v-bind:disabled="blocked"
                v-bind:dirty.sync="dirtyObj.inn"
            )
            
            z-input(
                v-show="hasInn"
                label="Наименование"
                v-model="customer.name"
                :required="!!([1,3].indexOf(parseInt(customer.type))+1)"
                name="recipient_name"
                id="recipient_name"
                v-bind:disabled="!customer.allow_edit || blocked"
                v-validate="{'required': !!([1,3].indexOf(parseInt(customer.type))+1)}"
                v-bind:error="errors.first('recipient_name')"
                data-vv-name="recipient_name"
                v-bind:data-vv-as="' '"
                inline
                v-bind:dirty.sync="dirtyObj.name"
            )
            z-input(
                v-show="hasInn"
                v-if="parseInt(customer.type) != 3"
                name="recipient_kpp" 
                id="recipient_kpp" 
                label="КПП" 
                v-model="customer.kpp" 
                v-bind:error="errors.first('recipient_kpp')"
                v-bind:minlength="9"
                v-bind:maxlength="9"
                v-bind:disabled="(!customer.allow_edit || blocked) && !customer.allow_edit_kpp"
                type="number"
                :required="parseInt(customer.type) == 1 ? true : false"
                v-validate="parseInt(customer.type) == 1 ? 'required|max:9|min:9' : ''"
                data-vv-name="recipient_kpp"
                v-bind:data-vv-as="' '"
                inline
                v-bind:dirty.sync="dirtyObj.kpp"
            )
        div(v-show="customer && parseInt(customer.type) === 2")
            ZInputAutocomplete(
                v-bind:update-on-input="true"
                label="Номер паспорта"
                v-bind:items="customersFl"
                v-model="customer.passport_number"
                v-bind:callback="searchCustomerByPassport"
                v-on:select="selectCustomer"
                v-on:clear="clearCustomer"
                v-bind:length-on-search="4"
                display-property="passport_number"
                display-property-list="fl_passport_label"
                property="passport_number"
                name="recipient_passport_number"
                id="recipient_passport_number"
                v-bind:default="customer.passport_number"
                mask="99 99 999999"
                :required="(parseInt(customer.type) === 2 ? true : false)"
                v-validate="(parseInt(customer.type) === 2 ? 'required' : '')"
                validate="passport"
                v-bind:error="errors.first('recipient_passport_number')"
                data-vv-name="recipient_passport_number"
                v-bind:data-vv-as="' '"
                ref="passport"
                v-bind:disabled="blocked"
                inline
                v-bind:dirty.sync="dirtyObj.passport"
            )
            z-input(
                v-show="hasPassport"
                label="ФИО"
                v-model="customer.name"
                name="recipient_fio"
                id="recipient_fio"
                :required="true"
                v-bind:disabled="!customer.allow_edit || blocked"
                v-validate="'required'"
                v-bind:error="errors.first('recipient_fio')"
                data-vv-name="recipient_fio"
                v-bind:data-vv-as="' '"
                inline
                v-bind:dirty.sync="dirtyObj.name"
            )

        z-input(
            label="Адрес для документов"
            id="recipient_docaddress"
            name="recipient_docaddress"
            v-model="customer.doc_address"
            v-bind:disabled="blocked"
            v-validate="'min:1|max:1000'"
            v-bind:data-vv-as="' '"
            v-bind:error="errors.first('doc_address')"
            v-bind:dirty.sync="dirtyObj.doc_address"
            inline
        )

        multy-autocomplete(
            v-show="hasInn || hasPassport"
            ref="contact"
            placeholder="Контактное лицо"
            label="Контактное лицо"
            display-property="label"
            property="name"
            return="id"
            v-model="customer.attached_contacts"
            v-bind:showOnFocus="true"
            v-bind:items="contacts"
            v-bind:show-search-input="false"
            v-on:select="selectContact"
            :required="true"
            v-bind:can-add="true"
            id="recipient_contact"
            name="recipient_contact"
            v-validate="'required'"
            v-bind:error="errors.first('recipient_contact')"
            data-vv-name="recipient_contact"
            v-bind:data-vv-as="' '"
            v-bind:tolltip-fields="{phone: 'Тел', email: 'E-mail'}"
            inline
            v-bind:dirty.sync="dirtyObj.contacts"
        )
            z-input(
                name="recipient_contact_name" id="recipient_contact_name" label="Имя" required v-model="newContact.name" 
                v-validate="'required|alpha_spaces'" v-bind:error="errors.first('contact.recipient_contact_name')"
                data-vv-name="recipient_contact_name"
                v-bind:data-vv-as="' '"
                data-vv-scope="contact"
            )    
            z-input(
                name="recipient_contact_phone" id="recipient_contact_phone" label="Телефон" v-model="newContact.phone" mask="+7 (999) 999-99-99"
                v-validate="{required: true, regex: /^\\+7 \\(\\d{3}\\) \\d{3}-\\d{2}-\\d{2}$/ }" v-bind:error="errors.first('contact.recipient_contact_phone')"
                data-vv-name="recipient_contact_phone"
                v-bind:data-vv-as="' '"
                data-vv-scope="contact"
            )
            z-input(
                name="recipient_contact_email" id="recipient_contact_email" label="E-mail" v-model="newContact.email" 
                v-validate="'email'" v-bind:error="errors.first('contact.recipient_contact_email')"
                data-vv-name="recipient_contact_email"
                v-bind:data-vv-as="' '"
                data-vv-scope="contact"
            )
            md-button.md-primary.md-dense(v-on:click="saveContact") Сохранить
</template>
<script>
    import ZInputAutocomplete from '@/components/ZInputAutocomplete'
    import moment from "moment"
    import Properties from '@/components/Properties'
    import WacomSignature from '@/components/WacomSignature';
    import MultyAutocomplete from '@/components/MultyAutocomplete';
    import ZInput from '@/components/ZInput';
    import ZSelect from '@/components/ZSelect';
    export default {
        name: 'recipient',
        props: {
            value: {
                type: Object,
                default: () => {
                    return {
                        id: null,
                        hid: null,
                        created_at: null,
                        updated_at: null,
                        name: null,
                        type: 1,
                        inn: null,
                        kpp: null,
                        passport_number: null,
                        checking_account: null,
                        correspondent_account: null,
                        bic: null,
                        bank: null,
                        sort: 100,
                        phone: null,
                        email: null,
                        nds: 0,
                        attached_contacts: [],
                        addresses: [],
                        contacts: []
                    }
                }
            },
            customersUl: {
                type: Array,
                default: []
            },
            customersFl: {
                type: Array,
                default: []
            },
            block: {
                type: Boolean,
                default: false
            },
            searchByInnCallback: {
                type: Function,
                default: () => {}
            },
            searchCustomerByPassportCallback: {
                type: Function,
                default: () => {}
            },
            breakCustomerCallback: {
                type: Function,
                default: () => {}
            },
            dirty: {
                type: Boolean,
                default: false
            },

            isUserHasHighPermission: {
                type: Boolean,
                default: false
            },
            isUserAgent: {
                type: Boolean,
                default: false
            },
            isUserAdmin: {
                type: Boolean,
                default: false
            },
            isUserManager: {
                type: Boolean,
                default: false
            },

            isDealCanceled: {
                type: Boolean,
                default: false
            },
            isIssueToTransfer: {
                type: Boolean,
                default: false
            },
            isEnteredToStock: {
                type: Boolean,
                default: false
            },
            isIssusedToClient: {
                type: Boolean,
                default: false
            },            
        },
        components: {
            Properties,
            ZInputAutocomplete,
            WacomSignature,
            MultyAutocomplete,
            ZInput, ZSelect
        },
        data() {
            return {
                parent: null,
                contacts: [],
                newContact: {
                    id: null,
                    name: null,
                    description: null,
                    phone: null,
                    email: null,
                    customer_id: null,
                    sort: null
                },
                newContactDefault: {
                    id: null,
                    name: null,
                    description: null,
                    phone: null,
                    email: null,
                    customer_id: null,
                    sort: null
                },
                customer: {
                    id: null,
                    hid: null,
                    created_at: null,
                    updated_at: null,
                    name: null,
                    type: 1,
                    inn: null,
                    kpp: null,
                    passport_number: null,
                    checking_account: null,
                    correspondent_account: null,
                    bic: null,
                    bank: null,
                    sort: 100,
                    phone: null,
                    email: null,
                    nds: 0,
                    attached_contacts: [],
                    addresses: [],
                    contacts: []
                },
                dirtyObj: {
                    type: false,
                    inn: false,
                    name: false,
                    kpp: false,
                    passport: false,
                    contacts: false,
                    doc_address: false
                }
            }
        },
        computed: {
            blocked() {
                // Если пользователь администратор, то он всегда может редактировать получателя
                if (this.$props.isUserAdmin) return false;

                // Остальные условия сработают только для представителя и менеджера
                
                // Если заявка отменена, то ничего редактировать нельзя
                if (this.$props.isDealCanceled) return true;

                // Если заявка выдана клиенту и пользователь не админ, тогда он не может редактировать параметры получателя
                if (this.$props.isIssusedToClient && !this.$props.isUserAdmin) return true;

                // Если заявка была выдана на перемещение или принята с перемещения, то менять получателя может только админ или менеджер
                if ((this.$props.isIssueToTransfer || this.$props.isEnteredToStock) && !this.$props.isUserAdmin && !this.isUserManager) return true;
            },            
            hasInn() {
                return this.customer.inn && (this.customer.inn.length >= 10);
            },
            hasPassport() {
                return this.customer.passport_number && (this.customer.passport_number.replace(/\D/g, "").length >= 10);
            },
            isDirty() {
                return !!Object.values(this.dirtyObj).find(item => item);
            }
        },
        watch: {
            '$props.value': {
                deep: true,
                handler(value) {
                    this.init(value);
                }
            },
            'customer': {
                deep: true,
                handler(customer) {
                    this.$emit('change', customer);
                    this.$emit('input', customer);
                    this.prepareContacts();
                }
            },
            'customer.contacts': {
                deep: true,
                handler(contacts) {
                    this.$emit('change-contacts', 'recipient', contacts);
                }
            },
            'isDirty'(val) {
                if (val) this.emitDirty();
            }
        },
        methods: {
            emitDirty() {
                this.$emit('update:dirty', this.isDirty);
            },
            init(customer) {
                if (customer && JSON.stringify(customer) != JSON.stringify(this.customer)) {
                    this.validateClear();
                    if (customer.attached_contacts && customer.attached_contacts.length) customer.attached_contacts = Object.assign([], customer.attached_contacts.map(contact => {
                        contact.label = contact.name + (contact.phone ? (', ' + contact.phone) : '') + '';
                        return contact;
                    }));
                    this.customer = Object.assign({}, customer);
                }
                this.prepareContacts();
            },
            prepareContacts() {
                if (!this.customer || !this.customer.contacts || !this.customer.contacts.length) this.contacts = [];
                else this.contacts = Object.assign([], this.customer.contacts.map(contact => {
                    contact.label = contact.name + (contact.phone ? (', ' + contact.phone) : '') + '';
                    return contact;
                }));
                if (this.customer.attached_contacts) this.customer.attached_contacts.map(contact => {
                    contact.label = contact.name + (contact.phone ? (', ' + contact.phone) : '') + '';
                    return contact;
                });
            },
            validateClear() {
                this.errors.clear();
                this.$validator.errors.clear();
                this.$validator.reset();
                if (this.$refs.inn) this.$refs.inn.validateClear();
                if (this.$refs.passport) this.$refs.passport.validateClear();
            },
            searchCustomerByInn(inn) {
                return this.searchByInnCallback(inn, 'recipient', this.$refs.inn);
            },
            selectCustomer(value, customer) {                
                this.customer = Object.assign({}, customer);
            },
            searchCustomerByPassport(passport) {
                return this.searchCustomerByPassportCallback(passport, 'recipient', this.$refs.passport);
            },
            changeType() {
                this.customer.id = null;
                this.customer.inn = null;
                this.customer.name = null;
                this.customer.passport_number = null;
            },
            clearCustomer() {
                return this.breakCustomerCallback('recipient');
            },
            selectContact(item) {},
            saveContact() {
                this.$validator.validateAll('contact').then(valid => {
                    if (!valid) return;
                    if (this.$refs.contact) {
                        this.newContact.sort = 100;
                        this.newContact.customer_id = this.customer.id;

                        //Если контрагент уже существует, сохраняем контакт на БЕ
                        if (this.customer.id && this.customer.id != 'new') this.$store.dispatch('customers/addCustomerContacts', {contacts: this.newContact}).then(contact => {
                                if (!contact || !contact.id) return;
                                this.newContact = Object.assign({}, contact);
                                this.customer.contacts.push(Object.assign({}, this.newContact));
                                setTimeout(() => { //Без setTimeout инпут this.$refs.contact не успевает обработать новый список КЛ и они начинают дублироваться, nextTick не помогает
                                    this.$refs.contact.selectItem(this.newContact, true);    
                                    this.$refs.contact.hideAddForm();
                                    this.newContact = Object.assign({}, this.newContactDefault);
                                }, 0);
                            });
                        else { //Иначе просто добавляем его в список (сохранение произойдёт на БЕ в момент сохранения всей заявки)
                            this.customer.contacts.push(Object.assign({}, this.newContact));
                            setTimeout(() => { //Без setTimeout инпут this.$refs.contact не успевает обработать новый список КЛ и они начинают дублироваться
                                this.$refs.contact.selectItem(this.newContact, true);    
                                this.$refs.contact.hideAddForm();
                                this.newContact = Object.assign({}, this.newContactDefault);
                            }, 0);
                        }
                    }
                });
            },
            async validate() {
                let valid = await this.$validator.validateAll();
                //Проверка только для юрика
                let isValidSelection = await new Promise((resolve, reject) => {
                    if ((!this.customer || (!this.customer.id && !this.customer.hid)) && parseInt(this.customer.type) != 2) {
                        this.$store.commit('showSnackbar', [
                            ('Контрагент: Получатель<br>' +
                            (this.customer.inn  ? ('ИНН: ' + this.customer.inn + '<br>') : '') +
                            (this.customer.name ? ('Название: ' + this.customer.name + '<br>') : '') +
                            'Не действительный.<br><br>Проверьте контрагента по <a href="' + this.$root.config.egrulUrl + '" target="_blank" style="color: #fff; text-decoration: underline;">ссылке</a>'),
                            10000, 'error'
                        ]);
                        this.$nextTick(() => resolve(false));
                    } else resolve(true);
                });
                
                if (!isValidSelection) return false;
                return valid;
            }
        },
        created() {
            this.$nextTick(() => this.init(this.$props.value));
        },
    }
</script>



// WEBPACK FOOTER //
// Recipient.vue?5a92da32